import DOMPurify from 'dompurify';

/**
 * DOMPurify configuration for comment sanitization
 * Only allows safe formatting tags used by the rich text editor
 */
const sanitizeConfig = {
  ALLOWED_TAGS: ['p', 'strong', 'em', 'u', 'ins', 'ul', 'ol', 'li', 'a', 'br', 'span'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'style', 'form', 'input', 'img'],
  FORBID_ATTR: ['onclick', 'onerror', 'onload', 'onmouseover', 'style', 'class'],
};

// Add noopener noreferrer to all links for security
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
  }
});

/**
 * Sanitizes HTML content to prevent XSS attacks
 * @param {string} html - Raw HTML string to sanitize
 * @returns {string} - Sanitized HTML string safe for rendering
 */
export const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, sanitizeConfig);
};

/**
 * Detects if a string contains HTML tags
 * Used to determine if content is rich text or plain text (legacy)
 * @param {string} text - Text to check
 * @returns {boolean} - True if HTML tags detected
 */
export const isHtmlContent = (text) => {
  if (!text) return false;
  // Check for common HTML tags used by the rich text editor
  return /<(p|strong|em|u|ins|ul|ol|li|a|br|span)[^>]*>/i.test(text);
};

export default sanitizeHtml;
